<template>
    <div>
       <van-dialog v-model="initFlag" :show-confirm-button="false" :width="pageWidth1">
        <div style="width:100%;height:400px;padding-left:30px;padding-right:30px;box-sizing: border-box;">
            <div style="height:70px;line-height:70px;color:#07c260;font-size:20px">平台升级通知</div>
            <div style="text-align: justify;color:#666;font-size:16px">亲爱的希望保会员：</div>
            <div style="height:5px"></div>
            <div style="text-align: justify;color:#666;font-size:16px">您好，感谢您使用【希望保投保】小程序，为了更好的保证您的用户体验，特邀请您前往最新升级改版的小程序<span style="font-weight:bold;color:#333;font-size:15px">【希望保保险】</span>。</div>
            <div style="height:10px"></div>
            <div style="text-align: justify;color:#666;font-size:16px">您的账号信息在<span style="font-weight:bold;color:#333;font-size:15px">【希望保保险】</span>小程序登录后不会受到任何影响。</div>
            <div style="height:10px"></div>
            <div style="text-align: justify;color:#666;font-size:16px">如使用过程中发生任何问题均可拨打我们的客服热线<span style="color:#07c260">4008933988</span>进行咨询和反馈。</div>
        </div>
        <div class="dialog-footer">
            <van-button type="primary" style="width:100%;" @click="goNewApp" >前往体验1</van-button>
            <!-- <van-button type="primary" style="width:100%;" @click="goNewApp3"  >前往体验3</van-button> -->
        </div>
        </van-dialog>
    </div>
</template>

<script>
import { Icon,Button, Toast,} from "vant";
import { mapState } from 'vuex'
import axios from "axios";

    export default {
        components: {
            [Icon.name]:Icon,
            [Button.name]: Button,
            [Toast.name]: Toast,
        },
        data(){
            return {
                pageWidth1: window.innerWidth - 40,
                initFlag:true,
                link:"",
            }
        },
        methods:{
            async goNewApp(){
                alert("接口测试")
                let res = await this.$http.get("/api/user/getscheme")
                if(res.code == 0){
                    if(res.t){
                        location.href = res.t
                    }else{
                        location.href = "https://www.baidu.com/"
                    }
                }else{
                    this.$toast(res.msg);
                }
             },
        }
    }
</script>